module.exports = __webpack_public_path__ + "img/icbcflexible.8b3bcbb0.png";